module.exports = __webpack_public_path__ + "static/media/relax_icon.ec22df1d.svg";